// Phase 6 — Track B T-B3. Token storage adapter.
//
// Cookie mode (Phase 6 web v1) does not need a token store — the browser
// owns the session cookie. The interface exists so the same ApiClient can
// run in bearer mode (later mobile / CLI clients) by injecting a real
// implementation (e.g. a SecureStore-backed adapter on iOS/Android).
//
// `NullTokenStore` is the cookie-mode default; every method is a no-op.

export interface TokenStore {
  getAccessToken(): Promise<string | null> | string | null;
  getRefreshToken(): Promise<string | null> | string | null;
  setTokens(args: {
    access_token: string;
    refresh_token: string;
  }): Promise<void> | void;
  clear(): Promise<void> | void;
}

export class NullTokenStore implements TokenStore {
  getAccessToken(): null {
    return null;
  }
  getRefreshToken(): null {
    return null;
  }
  setTokens(): void {
    // no-op
  }
  clear(): void {
    // no-op
  }
}

/**
 * In-memory token store — useful for tests and short-lived CLI contexts.
 * Production mobile callers should ship a SecureStore-backed adapter.
 */
export class InMemoryTokenStore implements TokenStore {
  private access: string | null = null;
  private refresh: string | null = null;

  getAccessToken(): string | null {
    return this.access;
  }
  getRefreshToken(): string | null {
    return this.refresh;
  }
  setTokens(args: { access_token: string; refresh_token: string }): void {
    this.access = args.access_token;
    this.refresh = args.refresh_token;
  }
  clear(): void {
    this.access = null;
    this.refresh = null;
  }
}
